// Submit a Quote form 
$('form.contact-form').on('submit', function(event) {
    event.preventDefault();
    $('form.contact-form button[type="submit"]').prop('disabled', true);
    var data = {};
    var formData = $('form.contact-form').serializeArray();
    for (var i in formData) {
        if (formData[i].value)
            data[formData[i].name] = formData[i].value;
        data.captcha = window.captcha;
    }
    if (typeof fbq !== 'undefined')
        fbq('track', 'Contact');
        $.post(
            process.env.API_HOST + "/lead/v1/web_submission", 
            data, 
            function(data) {
                window.alert(data);
                $('form.contact-form')[0].reset();
                $('form.contact-form button[type="submit"]').prop('disabled', false);
            }
        ).fail(function(err, d) {
            var str = '';
            if (err.status == 422) {
                const entries = Object.entries(err.responseJSON)
                for (var i in entries) {
                    for (var j in entries[i][1]) {
                        str += entries[i][1][j] + '\n';
                    }
                }
            }
            if (str)
                window.alert(str);
            else
                window.alert("Whoops! There was a problem submitting your form.");
            $('form.contact-form button[type="submit"]').prop('disabled', false);
    });
});